import { DIYServices } from '../services'
import { saveAs } from "file-saver"

const Ticket = {
    getMetadata: () => DIYServices.Ticket.getMetadata('createticket'),
    searchsite: (sitename) => DIYServices.Ticket.searchsite(sitename),
    searchfalocation: (falocation) => DIYServices.Ticket.searchfalocation(falocation),
    onSubmit: (form) => DIYServices.Ticket.onSubmit(form),
    executeAction: (payload) => DIYServices.Ticket.executeAction(payload),
    closeTicket: (id) => DIYServices.Ticket.closeTicket(id),
    getDetails: (id) => DIYServices.Ticket.getDetails(id)
}

const TicketSearch = {
    getMetadata: (setData) => {
        setData({ 'status': 'WORKING', 'data': { columns: {} } })
        DIYServices.Ticket.getMetadata('ticketsearch').then((response) => setData(response.data)).catch((error) => setData({ 'status': 'ERROR', 'data': { columns: {} } }))
    },
    getTickets: (paging, filters, setData) => DIYServices.TicketSearch.getTickets(paging, filters).then((response) => setData(response.data)).catch((error) => setData({ status: 'NEW', data: { data: [], count: 0 } }))
}

const Reports = {
    getDirectoryStructure: (payload) => DIYServices.Reports.getDirectoryStructure(payload),
    getFileContents: (filepath, filetype, setData, setStatus) => {
        setStatus('PENDING')
        setData(null)
        if (['log', 'txt'].includes(filetype)) {
            DIYServices.Reports.getFileContents(filepath, filetype).then((response) => {
                if (response.headers['content-type'].includes("application/json")) {
                    setData(response.data.data)
                    setStatus(response.data.status)
                }
            }).catch((error) => {
                setStatus('ERROR')
            })
        } else if (['pdf', 'jpg', 'png', 'html'].includes(filetype)) {
            DIYServices.Reports.getFileContents(filepath, filetype).then((response) => {
                if (response.headers['content-type'].includes("text/html")) {
                    setData(response.data)
                    setStatus('SUCCESS')
                }
            }).catch((error) => {
                setStatus('ERROR')
            })
        } else if (filepath === '') {
            setData(null)
            setStatus('NEW')
        } else {
            setStatus('UNKNOWN')
        }
    },
    getReport: (payload, setData) => {
        DIYServices.Reports.getReport(payload).then((response) => {
            if (response.headers['content-type'].includes("text/html")) {
                setData(response.data)
            }
        }).catch(console.error)
    },
    getHardwareReport: (sitename) => DIYServices.Reports.getHardwareReport(sitename)
}

const RSSI = {
    getMetadata: (setData) => {
        setData({ status: 'WORKING', data: { columns: {} } })
        DIYServices.RSSI.getMetadata().then((response) => setData(response.data)).catch((error) => setData({ status: 'ERROR', data: { columns: {} } }))
    },
    getTickets: (paging, filters, setData) => DIYServices.RSSI.getTickets(paging, filters).then((response) => setData(response.data)).catch((error) => setData({ status: 'NEW', data: { data: [], count: 0 } })),
    getTicketHistory: (quantumId, workorder, setData) => DIYServices.RSSI.getTicketHistory(quantumId, workorder).then((response) => setData(response.data.data)).catch((error) => setData([])),
    onAction: (payload) => DIYServices.RSSI.onAction(payload),
    showFile: (payload) => DIYServices.RSSI.showFile(payload),
    download: (payload, name) => DIYServices.RSSI.download(payload).then((response) => {
        const binary = new Blob([response.data], { type: response.headers["content-type"] })
        saveAs(binary, name)
    }),
    getMyUsers: (payload) => DIYServices.RSSI.getMyUsers(payload),
    markChecklistItem: (payload) => DIYServices.RSSI.markChecklistItem(payload),
    deeplink: (payload) => DIYServices.RSSI.deeplink(payload),
}

const DIYActions = {
    Ticket: Ticket,
    TicketSearch: TicketSearch,
    Reports: Reports,
    RSSI: RSSI
}

export default DIYActions
